<script lang="ts">
import {defineComponent} from 'vue'
import {ROUTES} from "../router";
import {mapGetters} from "vuex";

export default defineComponent({
    name: "MediaGalleryNavigation",
    computed: {
        ...mapGetters({
            count: 'getCollectedAssetCount'
        }),
        ROUTES() {
            return ROUTES
        }
    }
})
</script>

<template>
    <div class="container media-gallery-navigation">
        <div class="row">
            <div class="col-12 media-gallery-navigation__list">
                <router-link class="media-gallery-navigation__item headline-2" active-class="navigation-active" :to="{name: ROUTES.SEARCH}">
                    {{ $t('mediaGallery.navigation.mediaSearch.label') }}
                </router-link>
                <router-link class="media-gallery-navigation__item headline-2" active-class="navigation-active" :to="{name: ROUTES.COLLECTION}">
                    {{ $t('mediaGallery.navigation.collection.label') }}
                    <span class="media-gallery-navigation__item-count" v-if="count > 0">{{count}}</span>
                </router-link>
            </div>
        </div>
    </div>
</template>
